<template>
    <div class="d-flex">
        <!-- <v-col :class="`mx-0 my-0 ${url?'pr-0':''}`"> -->
            <v-file-input
                :label="requiredCharLabel"
                filled
                color="success"
                v-model="value" 
                hide-details="auto" 
                outlined 
                dense 
                :rules="rule"
                :append-icon="appendIcon??'mdi-paperclip'"
                prepend-icon=""
                :multiple="multiple"
                :error-messages="errorMessages"
                @click:clear="cleared"
                :accept="accept"
                :disabled="disabled"
                :loading="loading"
            ></v-file-input>
            <div v-if="exturl" >
                <alternativeButton
                :class="`ml-2 btn primary max-h`"
                :props="openUrlBtn"
                
            ></alternativeButton>
           
            <alternativeButton
                :class="`mx-1 btn error max-h`"
                :props="deleteBtn"
            ></alternativeButton>
            </div>
            
        <!-- </v-col> -->
        
    </div>

   

</template>
<script>
// import { observable } from 'vue';
export default {
    props: ['valueInput', 'rule', 'label', 'multiple', 'errorMessages', 'url', 'accept', 'disabled', 'loading', 'appendIcon'],
    model: {
        prop: 'value',
        event: 'valueChange'
    },
    computed: {
        value: {
            get: function() {
                return this.valueInput
            },
            set: function(value) {
                //console.log(value)
                this.$emit('valueChange', value)
            }
        },
        requiredCharLabel:{
            get: function(){
                if(this.label == "" || this.label == undefined)
                    return "";
                const response = this.label + " *";
                for (let i = 0; i < (this?.rule?.length??[]); i++) {
                    if(this.rule[i]([]) != true){
                        return response;
                    }
                }
                return this.label;
            }
        },
        
        exturl(){
            return this.url;
        }
    },
    data(){
        return{
            // keyV: observable(0),
            openUrlBtn: {
                text: "",
                icon: "mdi-eye-outline",
				to: "",
				block: false,
                textClass:"",
                click: ()=>{this.openUrl(this.url)}
            },
            deleteBtn: {
                text: "",
                icon: "mdi-delete-outline",
                textClass:"white--text",
				to: "",
				block: false,
                click: ()=>{this.delete()}
            },
        }
    },
    methods:{
        openUrl(fileUrl){
            window.open(fileUrl,"download")
        },
        delete(){
            this.$emit('update:url', '');
        },
        cleared(){
            this.$emit('cleared:file','');
        }
    }
    
}
</script>

<style lang="scss" >
//    .finp> .v-input__control>.v-input__slot>.v-input__append-inner>{
//       margin-top: 0px !important;
//    }

    //align icons
    .v-text-field--enclosed.v-input--dense:not(.v-text-field--solo).v-text-field--outlined .v-input__append-inner{
        align-self: center !important;
        margin-top:  unset !important;
    }


    .max-h{
        height: 2.4375rem !important;
    }
  
</style>

